import * as Cookies from '../utils/cookies';
import axios from 'axios';

export async function addPicPlayer(userId, profilePic) {
  const token = Cookies.getToken();


  const formData = new FormData();
  formData.append('profile_pic', profilePic);


  const res = await axios({
    method: 'PATCH',
    url: process.env.REACT_APP_API_URL + `/api/users/players/${userId}/`,
    headers: { Authorization: `Bearer ${token}` },
    data: formData,
  });

  return res;
}
